import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var Check = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M13.05 24a1 1 0 01-.73-.32l-7.05-7.62a1 1 0 011.46-1.36l6.32 6.83L25.27 8.32a1 1 0 011.47 1.36l-12.95 14a1 1 0 01-.74.32z" })), '0 0 32 32', 'Check');
//# sourceMappingURL=Check.js.map